import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { ApplicationQuery } from './ApplicationQuery';
import { ApplicantQuery } from './ApplicantQuery';
import { PartyQuery } from './PartyQuery';
import { PolicyDocQuery } from './PolicyDocQuery';
import { FollowUp } from './FollowUp';
import { CustomerQuery } from './CustomerQuery';
import { Person } from './Person';

@supertypeClass({ toClient: true, toServer: true })
export class PolicyQuery extends Everything {
  wasCanceledDeclinedRejected() {
    const workflowState = this.workflowState || this.uwWorkflowState;
    return !!workflowState && /Canceled|Rejected|Declined/.test(workflowState);
  }

  get isPrimary() {
    return this.type === 'primary';
  }

  get ownerPerson(): Person | null {
    return this.owner && this.owner instanceof Person ? this.owner : null;
  }

  set ownerPerson(person) {
    this.owner = person;
  }

  @property({ getType: () => ApplicationQuery })
  application: ApplicationQuery;

  @property({ sensitiveData: true })
  policyNumber: string;

  @property()
  type: string;

  @property()
  effectiveDate: Date;

  @property()
  finalRateClass: string;

  @property()
  finalAlgoRateClass: string;

  @property()
  aUEffectiveDate: Date;

  @property()
  acceleratedRateClass: string;

  @property()
  tLICEffectiveDate: Date;

  @property()
  tLICRateClass: string;

  @property()
  workflowState: string;

  @property()
  uwWorkflowState: string;

  @property()
  futureWorkflowState: string;

  @property()
  workflowSubState: string;

  @property()
  futureWorkflowSubState: string;

  @property()
  invite: string;

  @property()
  workflowStateUpdate: Date;

  @property()
  submittedAt: Date;

  @property()
  product: string;

  @property()
  faceAmount: number;

  @property()
  term: number;

  @property()
  flatExtras: number;

  @property({ getType: () => ApplicantQuery })
  insured: ApplicantQuery;

  @property({ getType: () => PartyQuery })
  owner: PartyQuery;

  @property({ type: Array, getType: () => PolicyDocQuery })
  policyDocs: Array<PolicyDocQuery>;

  @property({ type: Array, getType: () => FollowUp })
  followUps: Array<FollowUp>;

  @property({ getType: () => CustomerQuery })
  customer: CustomerQuery;

  constructor() {
    super();
  }

  static new() {
    return new PolicyQuery().init();
  }

  init() {
    return this;
  }

  hasActiveOffer() {
    return this.workflowSubState && this.workflowSubState.match(/Waiting for.*(Acceptance|Signature)/) ? true : false;
  }
}
